import { Service } from "@/apps/credit-line/services/network.service";
import { AuthenticationHelper } from "@/apps/credit-line/helpers/authentication.helper";
import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";

const creditLineService = new Service();

/**
 * If the user’s credit limit is zero, redirect to the “coming soon” view.
 */
export async function checkZeroLimitGuard(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
): Promise<void> {
  const deviceTag = AuthenticationHelper.getDeviceTag();
  if (!deviceTag) {
    // nothing to fetch if there’s no device tag
    return;
  }

  const response = await creditLineService.getCreditLineSummary({ deviceTag });
  const creditLimit = Number(response.data?.creditLimit ?? 0);

  if (creditLimit === 0) {
    next({ name: "YourLineComingSoonView", replace: true });
  } else {
    next();
  }
}
